import React, { FC, useRef, useEffect } from 'react';
import { css } from 'linaria';
import cn from 'clsx';

const TransitionBGStyles = css`
  transition: left 0.3s ease-out, right 0.3s ease-out;
`;
const TransitionTextStyles = css`
  transition: color 0.3s ease-out;
`;

interface OptionProps {
  className?: string;
  index: number;
  content?: string;
  active: boolean;
  callback: any;
  text: string;
}

const ToggleSwitchOption = React.memo(
  // eslint-disable-next-line
  React.forwardRef(({ className, index, text, active, callback }: OptionProps, ref) => (
    <label
      className={cn(
        className,
        TransitionTextStyles,
        'z-0 cursor-pointer border-0 paragraph-medium px-4 text-white',
        { 'cursor-default': active, '!text-gatsby': !active }
      )}
      onClick={() => callback(index, 'price_toggle')}
      // @ts-expect-error
      ref={ref}
    >
      <input autoComplete="off" checked={active} className="hidden" type="radio" value={index} />
      {text}
    </label>
  ))
);

interface Props {
  className?: string;
  options: any[];
  toggleValue: number;
  toggleCallback: any;
}

const ToggleSwitch: FC<Props> = (props) => {
  const { className, options, toggleCallback, toggleValue } = props;
  const switchContainerRef = useRef(null);
  const highlightRef = useRef(null);
  const selectionRef = useRef(null);
  useEffect(() => {
    const switchContainerRect =
      // @ts-expect-error
      switchContainerRef.current.getBoundingClientRect();
    // @ts-expect-error
    const selectedItemRect = selectionRef.current.getBoundingClientRect();

    // @ts-expect-error
    highlightRef.current.style.left = selectedItemRect.left - switchContainerRect.left + 'px';
    // @ts-expect-error
    highlightRef.current.style.right = switchContainerRect.right - selectedItemRect.right + 'px';
  });

  return (
    <div
      className={cn(
        className,
        TransitionBGStyles,
        `flex relative rounded-full bg-gallery border-box border border-gatsby box-content p-0.5`
      )}
      ref={switchContainerRef}
    >
      <div
        className={`absolute h-6 z-auto rounded-full bg-gatsby ${TransitionBGStyles}`}
        ref={highlightRef}
      />
      {options.map((option: string, index) => (
        <ToggleSwitchOption
          active={toggleValue === index}
          callback={toggleCallback}
          index={index}
          key={index}
          ref={toggleValue === index ? selectionRef : null}
          text={option}
        />
      ))}
    </div>
  );
};

export default React.memo(ToggleSwitch);
